import React from 'react';
// dls
import { TextButton } from '@swiggy-private/dls-web-core/dist/components/TextButton';
import { Button } from '@swiggy-private/dls-web-core/dist/components/Button';
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// constants
import { Phrases } from '@/pages/instamart/campaign/create/widgets/Nudge/constants';
// widgets
import CloseIcon from '@/widgets/CloseIcon';
// styles
import styles from './ModalContent.module.scss';
const ModalContent = ({ setShowWarningModal, campaignOperation }) => {
    const modalClose = () => setShowWarningModal(false);
    return (React.createElement("div", { className: styles.modal },
        React.createElement(Text, { variant: DlsFontVariants.header_H2_Black, color: DlsColorTokens.text_Highest_Emphasis }, Phrases.SUBMIT_CAMPAIGN_MODAL_TITLE),
        React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis, className: styles.modalText }, Phrases.SUBMIT_CAMPAIGN_MODAL_SUBTITLE),
        React.createElement("div", { className: styles.modalButtons },
            React.createElement(TextButton, { onClick: modalClose, className: styles.modalCancelButton, buttonSize: "medium", color: DlsColorTokens.primary }, "Cancel"),
            React.createElement("div", { className: styles.modalPrimaryButton },
                React.createElement(Button, { variant: "primary", onClick: () => campaignOperation() }, "Submit Campaign"))),
        React.createElement(CloseIcon, { className: styles.closeIcon, onModalClose: modalClose })));
};
export default ModalContent;
